module.exports = __webpack_public_path__ + "fonts/NunitoSans_7pt-ExtraBoldItalic.5b3bc0e3.ttf";